export default __webpack_public_path__ + "static/media/Valorant.1d84762e.png";